import { render, staticRenderFns } from "./SelectedImageWithLaser.vue?vue&type=template&id=08436c21&scoped=true&"
import script from "./SelectedImageWithLaser.vue?vue&type=script&lang=ts&"
export * from "./SelectedImageWithLaser.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedImageWithLaser.vue?vue&type=style&index=0&id=08436c21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08436c21",
  null
  
)

export default component.exports